import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Cookies from 'js-cookie'
import { FixedMessage, withApplicationNotificationsContext } from '@adc/ui-adc'
import { COOKIE_REGISTER_SUCCESS } from '../constants/cookies'
import resendConfirmationEmail from '../utils/resendConfirmationEmail'
import {
  MESSAGE_BID_REGISTER_SUCCESS,
  MESSAGE_BID_REGISTER_SUCCESS_UNCONFIRMED,
  MESSAGE_RE_SEND_CONFIRMATION_EMAIL,
  MESSAGE_CHECK_YOUR_EMAIL_THEN_BID,
  MESSAGE_CHECK_YOUR_EMAIL_THEN_OFFER,
} from '../statics'

class RegistrationBanner extends Component {
  static propTypes = {
    isUserAuthenticated: PropTypes.bool.isRequired,
    isUserConfirmed: PropTypes.bool.isRequired,
    isUserRegisteredForAuction: PropTypes.bool.isRequired,
    email: PropTypes.string.isRequired,
    notifications: PropTypes.object.isRequired,
    shouldShowSealedBidTreatment: PropTypes.bool.isRequired,
  }

  state = {
    showRegisterSuccess: false,
  }

  componentDidMount() {
    if (Cookies.get(COOKIE_REGISTER_SUCCESS)) {
      Cookies.remove(COOKIE_REGISTER_SUCCESS)
      this.setState({ showRegisterSuccess: true }, () => {
        const { isUserConfirmed } = this.props
        /* NOTE: getMessageInfo depends on state.showRegisterSuccess, so we need to keep it in the callback */
        const messageInfo = this.getMessageInfo()
        const { message } = messageInfo

        if (message && isUserConfirmed) {
          // use setImmediate to ensure notifications objects are initialized
          setImmediate(() => {
            this.props.notifications.overlayBanner?.open({
              title: message,
            })
          })
        }
      })
    } else {
      this.setState({ showRegisterSuccess: false })
    }
  }

  handleConfirmationRequest = () => {
    resendConfirmationEmail(this.props.email, this.props.notifications)
  }

  resendConfirmationLink = () => (
    <a href='#' onClick={this.handleConfirmationRequest}>
      {MESSAGE_RE_SEND_CONFIRMATION_EMAIL}
    </a>
  )

  getMessageInfo = () => {
    // NOTE: this logic may result in no message being generated, and hence the
    // following condition will return null.  For example these cases:
    // (isUserAuthenticated && !showRegisterSuccess && (isUserConfirmed || !isUserRegisteredForAuction))
    //
    // Instead of trying to isolate out all the cases where no message should be generated,
    // (and creating big inverse logic conditions), this just determines cases where it should
    // show a message and otherwise return null.
    const {
      isUserAuthenticated,
      isUserConfirmed,
      isUserRegisteredForAuction,
      shouldShowSealedBidTreatment,
    } = this.props

    if (isUserAuthenticated) {
      if (this.state.showRegisterSuccess) {
        // right after registering for a bid, user may be confirmed or not
        return {
          role: 'success',
          elmId: isUserConfirmed
            ? 'message-bid-register-success'
            : 'message-bid-register-success-unconfirmed',
          message: isUserConfirmed
            ? MESSAGE_BID_REGISTER_SUCCESS
            : MESSAGE_BID_REGISTER_SUCCESS_UNCONFIRMED,
        }
      } else if (!isUserConfirmed && isUserRegisteredForAuction) {
        // not right after registration - just on reload of pdp, when user is not confirmed
        return {
          role: 'warning',
          elmId: 'message-bid-unconfirmed',
          message: shouldShowSealedBidTreatment
            ? MESSAGE_CHECK_YOUR_EMAIL_THEN_OFFER
            : MESSAGE_CHECK_YOUR_EMAIL_THEN_BID,
        }
      }
    }

    return {}
  }

  render() {
    const { isUserConfirmed } = this.props
    const messageInfo = this.getMessageInfo()
    const { role, elmId, message } = messageInfo
    if (message && !isUserConfirmed) {
      return (
        <FixedMessage role={role} className='u-mt-2' showIcon>
          <div data-elm-id={elmId}>
            {message}
            {isUserConfirmed ? (
              ''
            ) : (
              <span> {this.resendConfirmationLink()}</span>
            )}
          </div>
        </FixedMessage>
      )
    }

    return null
  }
}

export { RegistrationBanner }
export default withApplicationNotificationsContext(RegistrationBanner)
